export function canAddSelection(currentSize: number, maxSelection?: number): boolean {
  return maxSelection === undefined || currentSize < maxSelection;
}

export function limitSelection<T>(items: T[], maxSelection?: number): T[] {
  return maxSelection === undefined ? items : items.slice(0, maxSelection);
}
